// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).

import type { PublishedTermsApi } from '../types';
import { publishedTermsHttpApi } from './public-terms.api';
import { publishedTermsMockApi } from './public-terms.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const publishedTermsApi: PublishedTermsApi = useMock
  ? publishedTermsMockApi
  : publishedTermsHttpApi;
